import { disposableValue } from '../disposable-value';

/**
 * A disposable value to hold the current search session ID.
 **/
export const QUERY_UPDATED_TIME = disposableValue<number>();

/**
 * Gets the current query updated time.
 * Using disposableValue so we can track in BootstrapStore when the query was last updated.
 */
export const getQueryUpdatedTime = () => {
	return QUERY_UPDATED_TIME.value() || undefined;
};

/**
 * Sets the current query updated time to now.
 * Using disposableValue so we can track in BootstrapStore when the query was last updated.
 */
export const setQueryUpdatedTime = (): void => {
	QUERY_UPDATED_TIME.update(Date.now());
};

/**
 * Disposes the query updated time.
 */
export const disposeQueryUpdatedTime = (): void => {
	QUERY_UPDATED_TIME.dispose();
};
